const KEY = "sbb-attribution";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "fbclid"];

function read() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "null") || null;
  } catch (e) {
    return null;
  }
}

/** Capture first-touch attribution (landing page, referrer, UTM). Later UTM visits update latestUtm only. */
export function captureAttribution() {
  try {
    const params = new URLSearchParams(window.location.search);
    const utm = {};
    UTM_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) utm[k] = v.slice(0, 100);
    });
    const stored = read();
    if (!stored) {
      const fresh = {
        landingPage: (window.location.pathname + (window.location.search || "")).slice(0, 300),
        referrer: document.referrer || "direct",
        capturedAt: new Date().toISOString(),
        ...utm,
      };
      localStorage.setItem(KEY, JSON.stringify(fresh));
      return fresh;
    }
    if (Object.keys(utm).length) {
      const merged = { ...stored, latestUtm: { ...stored.latestUtm, ...utm } };
      localStorage.setItem(KEY, JSON.stringify(merged));
      return merged;
    }
    return stored;
  } catch (e) {
    return {};
  }
}

/** Attribution dict for form submissions — first-touch values plus any latest UTM overrides. No PII. */
export function getAttribution() {
  const a = read() || {};
  const out = {};
  if (a.landingPage) out.landingPage = a.landingPage;
  if (a.referrer) out.referrer = a.referrer;
  UTM_KEYS.forEach((k) => {
    const latest = a.latestUtm?.[k];
    const value = latest || a[k];
    if (value) out[k] = value;
  });
  return out;
}

/** Anonymous funnel event — never send bills, account numbers, emails or other personal info. */
export function track(type, extra = {}) {
  try {
    const payload = {
      type: String(type).slice(0, 40),
      path: window.location.pathname.slice(0, 200),
      referrer: (document.referrer || "").slice(0, 300),
      utm: (() => {
        const a = getAttribution();
        const utm = {};
        UTM_KEYS.forEach((k) => { if (a[k]) utm[k] = a[k]; });
        return Object.keys(utm).length ? utm : null;
      })(),
      ...extra,
    };
    return fetch(`${process.env.REACT_APP_BACKEND_URL}/api/events`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      credentials: "include",
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    return undefined;
  }
}
